import { render, staticRenderFns } from "./SpecialRecruit.vue?vue&type=template&id=5a3e66f8&scoped=true&"
import script from "./SpecialRecruit.vue?vue&type=script&lang=js&"
export * from "./SpecialRecruit.vue?vue&type=script&lang=js&"
import style0 from "./SpecialRecruit.vue?vue&type=style&index=0&id=5a3e66f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3e66f8",
  null
  
)

export default component.exports